"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var PictureFrame_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/PictureFrame"));
var utilities_1 = require("@sportnet/ui/lib/Themes/utilities");
var MediaManagerImage_1 = tslib_1.__importDefault(require("@sportnet/ui/lib/MediaManagerImage"));
var em_1 = tslib_1.__importDefault(require("polished/lib/helpers/em"));
var prop_types_1 = tslib_1.__importDefault(require("prop-types"));
var react_1 = tslib_1.__importDefault(require("react"));
var utilities_2 = require("@sportnet/utilities");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var utilities_3 = require("../../utilities");
var Aside_1 = tslib_1.__importDefault(require("./Aside"));
var polished_1 = require("polished");
var mainLinkClass = 'widget-television-main-link';
var BACKGROUND_COLOR = '#1a2942';
var TABLET_BREAKPOINT = 'm';
var Wrapper = styled_components_1["default"].div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  .", " {\n    display: block;\n    height: 100%;\n  }\n\n  ", " {\n    flex-direction: row;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  .", " {\n    display: block;\n    height: 100%;\n  }\n\n  ", " {\n    flex-direction: row;\n  }\n"])), mainLinkClass, utilities_1.mb(TABLET_BREAKPOINT));
var Main = styled_components_1["default"].div(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  position: relative;\n  flex: 1;\n\n  border-radius: 0;\n\n  ", " {\n    background: ", ";\n    overflow: hidden;\n    border-radius: ", ";\n  }\n"], ["\n  display: flex;\n  position: relative;\n  flex: 1;\n\n  border-radius: 0;\n\n  ", " {\n    background: ", ";\n    overflow: hidden;\n    border-radius: ",
    ";\n  }\n"])), utilities_1.mb(TABLET_BREAKPOINT), BACKGROUND_COLOR, function (_a) {
    var theme = _a.theme;
    return theme.largeBorderRadius + " 0 0 " + theme.largeBorderRadius;
});
var MainPicture = styled_components_1["default"](MediaManagerImage_1["default"])(templateObject_3 || (templateObject_3 = tslib_1.__makeTemplateObject(["\n  height: auto;\n"], ["\n  height: auto;\n"])));
var StyledAside = styled_components_1["default"](Aside_1["default"])(templateObject_4 || (templateObject_4 = tslib_1.__makeTemplateObject(["\n  background: ", ";\n  border-radius: ", ";\n\n  ", " {\n    max-width: 40%;\n    border-radius: ", ";\n  }\n"], ["\n  background: ", ";\n  border-radius: ",
    ";\n\n  ", " {\n    max-width: 40%;\n    border-radius: ",
    ";\n  }\n"])), BACKGROUND_COLOR, function (_a) {
    var theme = _a.theme;
    return "0 0 " + theme.largeBorderRadius + " " + theme.largeBorderRadius;
}, utilities_1.mb(TABLET_BREAKPOINT), function (_a) {
    var theme = _a.theme;
    return "0 " + theme.largeBorderRadius + " " + theme.largeBorderRadius + " 0";
});
var Overlay = styled_components_1["default"].div(templateObject_5 || (templateObject_5 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  ", "\n"], ["\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  ",
    "\n"])), polished_1.linearGradient({
    colorStops: ['rgba(0,0,0,0) 0%', BACKGROUND_COLOR + " 100%"]
}));
var Info = styled_components_1["default"].div(templateObject_6 || (templateObject_6 = tslib_1.__makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  font-size: 7vw;\n  padding: 0 0.7em 0.7em 0.7em;\n\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  font-size: 7vw;\n  padding: 0 0.7em 0.7em 0.7em;\n\n  ", " {\n    font-size: ", ";\n  }\n"])), utilities_1.mb(TABLET_BREAKPOINT), em_1["default"](38));
var Title = styled_components_1["default"].div(templateObject_7 || (templateObject_7 = tslib_1.__makeTemplateObject(["\n  color: #fff;\n  font-weight: bold;\n  margin-bottom: 0.1em;\n"], ["\n  color: #fff;\n  font-weight: bold;\n  margin-bottom: 0.1em;\n"])));
var Date = styled_components_1["default"].div(templateObject_8 || (templateObject_8 = tslib_1.__makeTemplateObject(["\n  font-size: 0.65em;\n  color: ", ";\n"], ["\n  font-size: 0.65em;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.color.fadedText;
});
var C = function (_a) {
    var renderLink = _a.renderLink, data = _a.data;
    var _b = utilities_2.getProp(data, ['data', 'primaryArticleFilter', 'articles'], []).slice(0, 6), mainArticle = _b[0], articles = _b.slice(1);
    if (!mainArticle) {
        return null;
    }
    return (react_1["default"].createElement(Wrapper, null,
        react_1["default"].createElement(Main, null,
            react_1["default"].createElement(PictureFrame_1["default"], { width: 4, height: 3 }, renderLink({
                type: utilities_3.WIDGET_LINK_TYPE.ARTICLE_DETAIL,
                payload: mainArticle,
                linkProps: {
                    className: mainLinkClass,
                    children: (react_1["default"].createElement(react_1["default"].Fragment, null,
                        react_1["default"].createElement(MainPicture, { picture: mainArticle.picture, naturalWidth: 900, naturalHeight: 675, height: "100%", script: "media" }),
                        react_1["default"].createElement(Overlay, null,
                            react_1["default"].createElement(Info, null,
                                react_1["default"].createElement(Title, null, mainArticle.name),
                                react_1["default"].createElement(Date, null, utilities_3.getArticleMeta(mainArticle))))))
                }
            }))),
        react_1["default"].createElement(StyledAside, { items: articles, renderLink: renderLink })));
};
C.propTypes = {
    data: prop_types_1["default"].shape({
        data: prop_types_1["default"].shape({
            primaryArticleFilter: prop_types_1["default"].shape({
                articles: prop_types_1["default"].array
            }),
            secondaryArticleFilter: prop_types_1["default"].shape({
                articles: prop_types_1["default"].array
            })
        }).isRequired
    }).isRequired,
    renderLink: prop_types_1["default"].func.isRequired
};
exports["default"] = C;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
